if (!customElements.get('eco-country-picker')) {
  customElements.define(
    'eco-country-picker',
    class EcoCountryPicker extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.eco-country-picker__toggle');
        this.panel = this.querySelector('.eco-country-picker__panel');

        this.button.addEventListener('click', this.onToggleClick.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.onDocumentClick = this.onDocumentClick.bind(this);
        document.addEventListener('click', this.onDocumentClick);
        this.querySelectorAll('.eco-country-picker__option').forEach((option) =>
          option.addEventListener('click', this.onOptionClick.bind(this))
        );
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      onToggleClick() {
        this.setOpen(this.button.getAttribute('aria-expanded') !== 'true');
      }

      setOpen(open) {
        this.button.setAttribute('aria-expanded', open.toString());
        this.panel.toggleAttribute('hidden', !open);
        if (open) this.updateDirection();
      }

      // Opens the panel upward when it would otherwise be cut off below - e.g. at the bottom of the
      // mobile menu drawer, whose scroll container clips it, or at the bottom of the page.
      updateDirection() {
        this.classList.remove('eco-country-picker--up');

        const clip = this.getClipRect();
        const toggleRect = this.button.getBoundingClientRect();
        const panelHeight = this.panel.getBoundingClientRect().height;
        const spaceBelow = clip.bottom - toggleRect.bottom;
        const spaceAbove = toggleRect.top - clip.top;

        if (spaceBelow < panelHeight && spaceAbove > spaceBelow) {
          this.classList.add('eco-country-picker--up');
        }
      }

      getClipRect() {
        let top = 0;
        let bottom = window.innerHeight;

        for (let el = this.parentElement; el && el !== document.body; el = el.parentElement) {
          const overflowY = getComputedStyle(el).overflowY;
          if (overflowY !== 'visible') {
            const rect = el.getBoundingClientRect();
            top = Math.max(top, rect.top);
            bottom = Math.min(bottom, rect.bottom);
          }
        }

        return { top, bottom };
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.setOpen(false);
      }

      // Only close when focus moves to another element outside the picker (e.g. tabbing away).
      // Pressing an option in Safari moves focus to the nearest focusable ancestor - a third-party
      // script (zeropartyforms custom_box.js) adds tabindex to the footer wrappers - or to nothing;
      // closing then hid the panel before the option's click landed. Outside clicks go to onDocumentClick.
      onFocusOut(event) {
        const next = event.relatedTarget;
        if (next && !this.contains(next) && !next.contains(this)) this.setOpen(false);
      }

      onKeyDown(event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.setOpen(false);
          this.button.focus();
        }
      }

      onOptionClick(event) {
        const option = event.currentTarget;

        if (option.getAttribute('aria-current') === 'true') {
          event.preventDefault();
          this.setOpen(false);
          return;
        }

        (window.dataLayer = window.dataLayer || []).push({
          event: 'country_selector',
          action: 'switch',
          from: this.dataset.siteCountry,
          to: option.dataset.country,
        });

        try {
          window.localStorage.setItem(COUNTRY_POPUP_STORAGE_KEY, 'manual_selection');
        } catch (error) {
          // localStorage unavailable (private browsing, etc.) - navigation still proceeds
        }

        // localStorage isn't shared across ecoatm.com / ecoatm.ca, so carry the choice to the
        // destination site, which saves it on arrival and suppresses its country pop-up. The link's
        // default navigation (after this handler) picks up the updated href.
        const url = new URL(option.href, window.location.href);
        url.searchParams.set(COUNTRY_CHOICE_URL_PARAM, 'manual_selection');
        option.href = url.toString();
      }
    }
  );
}
